import inscricaoEstagiario         from './inscricaoEstagiario/config';
import inscricaoOriginaria         from './inscricaoOriginaria/config';
import inscricaoSuplementar        from './inscricaoSuplementar/config';
import inscricaoTransferencia      from './incricaoTransferencia/config';
import pedidoCancelamento          from './pedidoCancelamento/config';
import pedidoReativacao            from './pedidoReativacao/config';
import pedidoLicenciamento         from './pedidoLincenciamento/config';
import pedidoBaixaLicenciamento    from './pedidoBaixaLicenciamento/config';
import pedidoProrrogacaoEstagio    from './pedidoProrrogacaoEstagio/config';
import pedidoRecadastramento       from './pedidoRecadastramento/config';
import pedidoPrimeiraViaExameOrdem from './pedidoPrimeiraViaExameOrdem/config';
import pedidoSegundaViaExameOrdem  from './pedidoSegundaViaExameOrdem/config';
import pedidoAlteracaoNome         from './pedidoAlteracaoNome/config';
import pedidoAnotacaoImpedimento   from './pedidoAnotacaoImpedimento/config';
import pedidoBaixaImpedimento      from './pedidoBaixaImpedimento/config';
import pedidoSolicitacaoSegundaVia from './pedidoSolicitacaoSegundaVia/config';
import pedidoJuntadaRecurso        from './pedidoJuntadaRecurso/config';
import pedidoJuntadaReconsideracao from './pedidoJuntadaReconsideracao/config';
import pedidoJuntadaDiligencia     from './pedidoJuntadaDiligencia/config';
import pedidoAlteracaoContratual   from './pedidoAlteracaoContratual/config';
import pedidoContratoAssociacaoSociedades from './pedidoContratoAssociacaoSociedades/config';
import pedidoDistratoAssociacaoSociedades from './pedidoDistratoAssociacaoSociedades/config';
import pedidoContratoAssociado from './pedidoContratoAssociado/config';
import pedidoDistratoAssociado from './pedidoDistratoAssociado/config';
import pedidoDistratoSociedade from './pedidoDistratoSociedade/config';
import pedidoRegistroAta from './pedidoRegistroAta/config';
import pedidoRegistroLivroDiario from './pedidoRegistroLivroDiario/config';
import pedidoRegistroSociedadeUnipessoal from './pedidoRegistroSociedadeUnipessoal/config';
import pedidoRegistroSociedadePluripessoal from './pedidoRegistroSociedadePluripessoal/config';
import pedidoRegistroFilialSociedade from './pedidoRegistroFilialSociedade/config';
import pedidoRetiradaUnilateral from './pedidoRetiradaUnilateral/config';
import pedidoJuntadaRecursoSociedade from './pedidoJuntadaRecursoSociedade/config';
import pedidoJuntadaReconsideracaoSociedade from './pedidoJuntadaReconsideracaoSociedade/config';
import pedidoJuntadaDiligenciaSociedade from './pedidoJuntadaDiligenciaSociedade/config';
import pedidoCopiaProcessoSociedade from './pedidoCopiaProcessoSociedade/config';
import pedidoTransformacaoSuplementarTransferencia from './pedidoTransformacaoSuplementarTransferencia/config';
import pedidoDesarquivamentoProcesso from './pedidoDesarquivamentoProcesso/config';
import pedidoEnvioTermoPosse from './pedidoEnvioTermoPosse/config';
import pedidoAlteracaoNomeCertificadoExameOrdem from './pedidoAlteracaoNomeCertificadoExameOrdem/config';

export const inscricao_estagiario = inscricaoEstagiario;
export const inscricao_originaria = inscricaoOriginaria;
export const inscricao_suplementar = inscricaoSuplementar;
export const inscricao_transferencia = inscricaoTransferencia;
export const pedido_cancelamento = pedidoCancelamento;
export const pedido_reativacao = pedidoReativacao;
export const pedido_licenciamento = pedidoLicenciamento;
export const pedido_baixa_licenciamento = pedidoBaixaLicenciamento;
export const pedido_prorrogacao_estagio = pedidoProrrogacaoEstagio;
export const pedido_recadastramento = pedidoRecadastramento;
export const pedido_PrimeiraViaExameDeOrdem = pedidoPrimeiraViaExameOrdem;
export const pedido_SegundaViaExameDeOrdem = pedidoSegundaViaExameOrdem;
export const pedido_alteracao_nome = pedidoAlteracaoNome;
export const pedido_anotacao_impedimento = pedidoAnotacaoImpedimento;
export const pedido_baixa_Impedimento = pedidoBaixaImpedimento;
export const pedido_solicitacao_segunda_via = pedidoSolicitacaoSegundaVia;
export const pedido_juntada_recurso = pedidoJuntadaRecurso;
export const pedido_juntada_reconsideracao = pedidoJuntadaReconsideracao;
export const pedido_juntada_diligencia = pedidoJuntadaDiligencia;
export const pedido_alteracao_contratual = pedidoAlteracaoContratual;
export const pedido_contrato_associacao_sociedades = pedidoContratoAssociacaoSociedades;
export const pedido_distrato_associacao_sociedades = pedidoDistratoAssociacaoSociedades;
export const pedido_contrato_associado = pedidoContratoAssociado;
export const pedido_distrato_associado = pedidoDistratoAssociado;
export const pedido_distrato_sociedade = pedidoDistratoSociedade;
export const pedido_registro_ata = pedidoRegistroAta;
export const pedido_registro_livro_diario = pedidoRegistroLivroDiario;
export const pedido_registro_sociedade_unipessoal = pedidoRegistroSociedadeUnipessoal;
export const pedido_registro_sociedade_pluripessoal = pedidoRegistroSociedadePluripessoal;
export const pedido_registro_filial_sociedade = pedidoRegistroFilialSociedade;
export const pedido_retirada_unilateral = pedidoRetiradaUnilateral;
export const pedido_juntada_recurso_sociedade = pedidoJuntadaRecursoSociedade;
export const pedido_juntada_reconsideracao_sociedade = pedidoJuntadaReconsideracaoSociedade;
export const pedido_juntada_diligencia_sociedade = pedidoJuntadaDiligenciaSociedade;
export const pedido_copia_processo_sociedade = pedidoCopiaProcessoSociedade;
export const pedido_transformacao_suplementar_transferencia = pedidoTransformacaoSuplementarTransferencia;
export const pedido_desarquivamento_processo = pedidoDesarquivamentoProcesso;
export const pedido_envio_termo_posse = pedidoEnvioTermoPosse;
export const pedido_alteracao_nome_certificado_exame_ordem = pedidoAlteracaoNomeCertificadoExameOrdem;